import React, {createContext, useState, useEffect, useContext} from "react";
import env from "../config/environment";

const ProjectDataContext = createContext();

function ProjectDataContextProvider({ children }) {
  const [projectData, setProjectData] = useState({
    projects: [],
    yearFilterOps: [],
    typeFilterOps: [],
    isLoading: true,
    errorOccurred: false
  });

  useEffect(() => {
    let unmounted = false;
    let updatedProjectData = {
      projects: [],
      yearFilterOps: [],
      typeFilterOps: [],
      isLoading: true,
      errorOccurred: false
    };
    
    fetch(env.agsrestapi + env.mapConfig.mapService + env.mapConfig.featureLayerIds[2] + env.dataFetchQuery)
        .then(response => response.json())
        .then(responseData => {
          if (!unmounted) {
            for (let i = 0; i < responseData.features.length; i++) {
              updatedProjectData.projects.push(responseData.features[i].attributes);

              if (responseData.features[i].attributes.FME_SCHED_YR && !updatedProjectData.yearFilterOps.includes(responseData.features[i].attributes.FME_SCHED_YR)) {
                updatedProjectData.yearFilterOps.push(responseData.features[i].attributes.FME_SCHED_YR);
              }
              
              if (responseData.features[i].attributes.FME_PROJ_TYPE) {
                let types = responseData.features[i].attributes.FME_PROJ_TYPE.split(", ");
                for (let j = 0; j < types.length; j++) {
                  if (!updatedProjectData.typeFilterOps.includes(types[j])) {
                    updatedProjectData.typeFilterOps.push(types[j]);
                  }
                }
              }
            }
            updatedProjectData.projects.sort((a, b) => (a.FME_PROJ_NM.toLowerCase() > b.FME_PROJ_NM.toLowerCase()) ? 1 : -1);
            updatedProjectData.yearFilterOps.sort();
            updatedProjectData.typeFilterOps.sort();
            updatedProjectData.isLoading = false;
            updatedProjectData.errorOccurred = false;
            setProjectData(updatedProjectData);
          }
            
        }).catch(e => {
          if (!unmounted) {
            console.log("Error occurred on data fetch: ", e);
            updatedProjectData.isLoading = false;
            updatedProjectData.errorOccurred = true;
            setProjectData(updatedProjectData);
          }
        });

        return () => { unmounted = true };
  }, []);

  return (
    <ProjectDataContext.Provider value={{ projectData }}>
      {children}
    </ProjectDataContext.Provider>
  );
}

export default ProjectDataContextProvider;

export function useProjectData() {
  const context = useContext(ProjectDataContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}
